/* eslint-disable import/no-anonymous-default-export */
export default {
    title: "Hello Word",
}
